(() => {
  const initializeGallery = (gallery) => {
    if (!gallery || gallery.dataset.galleryInitialized === 'true') return;

    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const previousButton = gallery.querySelector('[data-gallery-previous]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    let activeIndex = 0;

    if (slides.length < 2) {
      gallery.dataset.galleryInitialized = 'true';
      return;
    }

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    };

    previousButton?.addEventListener('click', () => showSlide(activeIndex - 1));
    nextButton?.addEventListener('click', () => showSlide(activeIndex + 1));

    gallery.dataset.galleryInitialized = 'true';
    showSlide(0);
  };

  const initializeShop = (section) => {
    if (!section || section.dataset.myteaShopInitialized === 'true') return;

    const tabs = [...section.querySelectorAll('[data-filter-tab]')];
    const panels = [...section.querySelectorAll('[data-filter-panel]')];
    const cards = [...section.querySelectorAll('[data-product-card]')];
    const clearButton = section.querySelector('[data-clear-filters]');
    const emptyMessage = section.querySelector('[data-filter-empty]');
    const status = section.querySelector('[data-filter-status]');
    let activeGroup = 'flavor';
    let activeValue = 'all';

    section.querySelectorAll('[data-card-gallery]').forEach(initializeGallery);

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const announceAndFilter = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const values = normalize(card.dataset.filterValues).split(/\s+/);
        const isVisible = activeValue === 'all' || values.includes(activeValue);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
      if (status) status.textContent = `${visibleCount} products shown`;
    };

    const setChoice = (button, scrollToCatalog = true) => {
      const panel = button.closest('[data-filter-panel]');
      panel?.querySelectorAll('[data-filter-value]').forEach((choice) => {
        const selected = choice === button;
        choice.classList.toggle('is-active', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });

      activeValue = normalize(button.dataset.filterValue) || 'all';
      announceAndFilter();

      if (scrollToCatalog && activeValue !== 'all') {
        section.querySelector('#shop-catalog')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const setGroup = (group) => {
      activeGroup = group;
      activeValue = 'all';

      tabs.forEach((tab) => {
        const selected = tab.dataset.filterTab === group;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        const selected = panel.dataset.filterPanel === group;
        panel.hidden = !selected;
        panel.querySelectorAll('[data-filter-value]').forEach((choice) => {
          const isAll = choice.dataset.filterValue === 'all';
          choice.classList.toggle('is-active', isAll);
          choice.setAttribute('aria-pressed', String(isAll));
        });
      });

      announceAndFilter();
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => setGroup(tab.dataset.filterTab)));
    panels.forEach((panel) => {
      panel.querySelectorAll('[data-filter-value]').forEach((button) => {
        button.addEventListener('click', () => setChoice(button));
      });
    });

    clearButton?.addEventListener('click', () => {
      setGroup(activeGroup);
      section.querySelector('[data-mytea-shop-filter]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    section.dataset.myteaShopInitialized = 'true';

    const requestedFlavor = normalize(new URL(window.location.href).searchParams.get('flavor'));
    const flavorPanel = panels.find((panel) => panel.dataset.filterPanel === 'flavor');
    const requestedChoice = [...(flavorPanel?.querySelectorAll('[data-filter-value]') || [])].find(
      (choice) => normalize(choice.dataset.filterValue) === requestedFlavor,
    );

    if (requestedChoice && requestedFlavor !== 'all') {
      setGroup('flavor');
      setChoice(requestedChoice, false);
    } else {
      announceAndFilter();
    }
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-mytea-shop-section]').forEach(initializeShop);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
